import React, { useState } from 'react';
import { OverflowWrapper, Button } from 'app/components';
import { CopySimple } from '@phosphor-icons/react';
import CopyToClipboard from 'react-copy-to-clipboard';

const PgOrderIdRow = ({ row }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (link) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
   
    <div className="row-container flex items-center gap-2">
      {row?.pg_payment_id ?
      (<>
        <OverflowWrapper>{row?.pg_payment_id}</OverflowWrapper>
        <p className="label-14 text-green-600">{copied ? 'Copied!' : null}</p>
        <CopyToClipboard onCopy={() => handleCopy(`${row?.pg_payment_id}`)} text={row?.pg_payment_id}>
          <CopySimple
            size={24}
            color={copied ? "grey" : "black"}
            className="cursor-pointer"
          />
        </CopyToClipboard>
      </>) : (
        <OverflowWrapper className = "text-red-600">N/A</OverflowWrapper>
      )}
    </div>
  );
};

export const COLUMNS_CONFIG = [
  {
    'label': 'Name',
    'path': 'name',
    'order': 1,
    'field': 'name',
    rowElement: ({ row }) => (
      <div className='flex flex-col gap-1 row-container'>
        <OverflowWrapper className="label-14">
          {row?.get_to_know_details?.details?.[0]?.full_name}
        </OverflowWrapper>
        {row?.get_to_know_details?.details?.length > 1 && (
          <div className='text-primary bg-light px-2 py-1 text-[11px] font-medium rounded'>GROUP BOOKING</div>
        )}
      </div>
    ),
  },
  {
    'label': 'Phone Number',
    'path': 'phone number',
    'order': 2,
    'field': 'phone number',
    rowElement: ({ row }) => (
      <div className='row-container'>
        <OverflowWrapper>
          {row?.get_to_know_details?.details?.[0]?.phone_number}
        </OverflowWrapper>
      </div>
    ),
  },
  {
    'label': 'Email',
    'path': 'email',
    'order': 3,
    'field': 'email',
    rowElement: ({ row }) => (
      <div className='row-container'>
        <OverflowWrapper>
          {row?.get_to_know_details?.details?.[0]?.email 
            || row?.get_to_know_details?.details?.[0]?.[row?.event_details?.get_to_know_details?.find((item) => item?.type === 'Email')?.id || '']}
        </OverflowWrapper>
      </div>
    ),
  },
  {
    'label': 'Ticket Count',
    'path': 'tickets_booked',
    'order': 4,
    'field': 'tickets_booked',
  },
  {
    'label': 'Amount',
    'path': 'total_price',
    'order': 5,
    'field': 'total_price',
  },
  {
    'label': 'Category',
    'path': 'category',
    'order': 6,
    'field': 'category',
    rowElement: ({ row }) => (
      <div className='row-container'>
      <OverflowWrapper>
        {row?.ticket_details?.[0]?.category}
      </OverflowWrapper>
    </div>
    ),
  },
  {
    'label': 'Transaction ID',
    'path': 'pg_order_id',
    'order': 7,
    'field': 'pg_order_id',
    rowElement:  ({ row }) => <PgOrderIdRow row={row} />
  },
  {
    'label': '',
    'path': 'action_items',
    'order': 7,
    'field': 'action_items',
  },
];

export const ATTENDEE_DETAILS = [
  {
    key: 'full_name',
    label: 'Name',
  },
  {
    key: 'category',
    label: 'Category',
  },
  {
    key: 'bookingId',
    label: 'Booking ID',
  },
  {
    key: 'email',
    label: 'Email',
  },
  {
    key: 'phone number',
    label: 'Phone Number',
  },
  {
    key: 'tickets_booked',
    label: 'Ticket Count',
  },
  
  {
    key: 'total_price',
    label: 'Amount Paid',
  },
  {
    key: 'booking_date',
    label: 'Purchased on',
  },
  {
    key: 'pg_order_id',
    label: 'Transaction ID',
  },
];

export const SORT_CONFIG = [
  { label: 'Recent', value: 'recent' },
  { label: 'Ticket', value: 'ticket' },
  { label: 'Amount', value: 'amount' },
];
